import * as React from 'react';
import {
  Menu,
} from '@material-ui/core';

interface ActionMenuProps {
  anchorEl: HTMLElement;
  handleClose: () => void;
}

const ActionMenu: React.FC<ActionMenuProps> = (
  {
    anchorEl, handleClose, children,
  },
) => (
  <Menu
    anchorEl={anchorEl}
    keepMounted
    open
    onClose={handleClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
  >
    {children}
  </Menu>
);

export default ActionMenu;
